import React from "react";

export function SettingsSectionCard({ title, subtitle, children, footer }) {
  return (
    <section className="rounded-2xl border border-[#EFEFEF] bg-white p-4 shadow-[0_1px_3px_rgba(15,23,42,0.04)] sm:p-6 md:p-8">
      <div className="mb-6">
        <h2 className="my-0 text-[16px] font-semibold text-[#111827]">{title}</h2>
        {subtitle ? (
          <p className="my-0 mt-1 text-[13px] text-[#6B7280]">{subtitle}</p>
        ) : null}
      </div>
      <div className="space-y-5">{children}</div>
      {footer ? (
        <div className="mt-6 flex flex-col-reverse gap-3 border-t border-[#F3F4F6] pt-5 sm:mt-8 sm:flex-row sm:flex-wrap sm:justify-end sm:pt-6 [&>div]:w-full sm:[&>div]:w-auto">
          {footer}
        </div>
      ) : null}
    </section>
  );
}
